module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-12.30ec2970.jpg";